window.customElements.define(
  "grid-layout-toggle",
  class GridToggle extends HTMLElement {
    constructor() {
      super();
      this.productGridContainer = document.querySelector('#ProductGridContainer');
      this.layoutVersionMobile = this.dataset.layoutVersionMobile || 1;
      this.layoutVersionDesktop = this.dataset.layoutVersionDesktop || 1;

      this.loadAndSetVersionsFromSessionStorage();

      this.layoutVersionMobileMax = 3;
      this.layoutVersionDesktopMax = 2;
    }

    connectedCallback() {
      this.addEventListener('click', this.onButtonClick.bind(this));
    }

    onButtonClick(event) {
      // increment layout versions
      if(this.layoutVersionMobile < this.layoutVersionMobileMax) {
        this.layoutVersionMobile++;
      } else {
        this.layoutVersionMobile = 1;
      }

      if(this.layoutVersionDesktop < this.layoutVersionDesktopMax) {
        this.layoutVersionDesktop++;
      } else {
        this.layoutVersionDesktop = 1;
      }

      // update button data attributes
      this.dataset.layoutVersionMobile = this.layoutVersionMobile;
      this.dataset.layoutVersionDesktop = this.layoutVersionDesktop;

      //update product grid data attributes
      this.productGridContainer.dataset.layoutVersionMobile = this.layoutVersionMobile;
      this.productGridContainer.dataset.layoutVersionDesktop = this.layoutVersionDesktop;

      // save versions to session storage
      this.saveVersionsToSessionStorage();
    }

    saveVersionsToSessionStorage() {
      sessionStorage.setItem('gridLayoutVersionMobile', this.layoutVersionMobile);
      sessionStorage.setItem('gridLayoutVersionDesktop', this.layoutVersionDesktop);
    }

    loadAndSetVersionsFromSessionStorage() {
      this.layoutVersionMobile = sessionStorage.getItem('gridLayoutVersionMobile') || this.layoutVersionMobile;
      this.layoutVersionDesktop = sessionStorage.getItem('gridLayoutVersionDesktop') || this.layoutVersionDesktop;

      this.dataset.layoutVersionMobile = this.layoutVersionMobile;
      this.dataset.layoutVersionDesktop = this.layoutVersionDesktop;

      this.productGridContainer.dataset.layoutVersionMobile = this.layoutVersionMobile;
      this.productGridContainer.dataset.layoutVersionDesktop = this.layoutVersionDesktop;
    }
  }
);
